<template>
  <div class="cb-pbody__wrap" ref="wrap" id="cb-pbody-wrap">
    <div class="cb-pbody__content">
      <ul class="cb-u-invoice">
        <li class="cb-u-invoice__list">
          <div class="cb-u-invoice__sno">
            <div class="cb-u-invoice__radio">
              <i class="icon-check cb-u-invoice__icon" aria-hidden="true"></i>  
            </div>
          </div>
          <div class="cb-u-invoice__info">
            <div class="cb-u-invoice__name">
            	<cb-placeholder :custom-class="'sm rect-lg'"></cb-placeholder>
            </div>
            <div class="cb-u-invoice__amount">
            	<cb-placeholder :custom-class="'st rect-sm'"></cb-placeholder>
            </div>
          </div>
          <div class="cb-u-invoice__details">
            <div class="cb-u-invoice__detail">
            	<cb-placeholder :custom-class="'sm rect-xl'"></cb-placeholder>
            </div>
            <div class="cb-u-invoice__detail">
            	<cb-placeholder :custom-class="'sm rect-xxl'"></cb-placeholder>
            </div>
          </div>
          <div class="cb-u-invoice__action cb-u-invoice__nodisplaymq">
          	<div v-for = "i in 3" class="cb-u-invoice__loader cb-transition__fade" :key="i">
          	</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script type="text/javascript">
import Placeholder from "@/components/collections/elements/Placeholder"
import Button from "@/components/collections/form/ButtonComponent"
export default {
  components : {
  	'cb-placeholder': Placeholder,
    'cb-button' : Button,
  },
}
</script>
